import React, { FC } from 'react';

import { Box } from '@rover/kibble/core';
import { ZIndex } from '@rover/kibble/styles';
import { useTheme } from '@rover/kibble/themes';

import { dropdownClickHandler } from '../menus/utilities';

import { NOTIFICATIONS_CENTER_DROPDOWN_ID } from './constants';

const DROPDOWN_HEIGHT_DESKTOP = '410px';
const DROPDOWN_WIDTH_DESKTOP = '400px';
const NAV_HEIGHT_MOBILE = '60px';
const NAV_HEIGHT_DESKTOP = '39px';

type Props = {
  isOpen: boolean;
  children: React.ReactNode;
  implementDjangoHacks: boolean;
};

const NotificationsCenterDropdown: FC<Props> = ({ isOpen, children, implementDjangoHacks }) => {
  const theme = useTheme();

  return (
    <Box
      data-testid="notifications-center-dropdown"
      onClick={dropdownClickHandler}
      id={NOTIFICATIONS_CENTER_DROPDOWN_ID}
      display={isOpen ? 'block' : 'none'}
      width={['100%', DROPDOWN_WIDTH_DESKTOP]}
      height={[`calc(100vh - ${NAV_HEIGHT_MOBILE})`, DROPDOWN_HEIGHT_DESKTOP]}
      minHeight={DROPDOWN_HEIGHT_DESKTOP}
      position="absolute"
      top={implementDjangoHacks ? [NAV_HEIGHT_MOBILE, NAV_HEIGHT_DESKTOP] : '100%'}
      right="0"
      zIndex={ZIndex.DROPDOWN.toString()}
      borderRadius={['0px', '0px 0px 4px 4px']}
      border={['0 none', `1px solid ${theme.colors.border.primary.toString()}`]}
      background="primary"
      sx={{
        overflow: 'hidden',
        boxShadow: ['', '0 2px 9px 0 rgba(0, 0, 0, 0.2)'],
      }}
      role="tooltip"
    >
      {children}
    </Box>
  );
};

export default NotificationsCenterDropdown;
